export const faqs = [
  {
    q: "爆料专区的内容多久更新一次？",
    a: "我们每天都会整理新的话题，通常早晚各更新一轮。遇到热度特别高的事件，会临时加更，确保你打开首页就能看到当天的最新动态。",
  },
  {
    q: "网站上的内容是从哪里来的？",
    a: "所有内容都来自公开渠道的信息整理，包括社交平台热议话题、媒体报道以及网友的公开讨论。我们只做汇总与梳理，不会凭空编造情节。",
  },
  {
    q: "看到的内容是真的吗？",
    a: "我们会标注话题的来龙去脉，但网络信息本身存在反转的可能。建议把它当作了解热议话题的入口，涉及当事人评价时保持谨慎，以官方回应为准。",
  },
  {
    q: "可以给爆料专区投稿或者提供线索吗？",
    a: "当然可以。你可以通过页面底部的邮箱联系我们，附上事情的大致经过和可查证的公开来源。经核实后我们会整理发布，并保护投稿人的隐私。",
  },
  {
    q: "为什么有的文章没有配图或者图片被替换了？",
    a: "出于版权与肖像权考虑，我们有时会使用氛围类配图替代原始图片。这样既能还原话题情境，也尽量避免对当事人造成二次影响。",
  },
  {
    q: "如何第一时间收到更新提醒？",
    a: "订阅页面下方的「每日爆料提醒」，留下邮箱即可。我们会把当天最值得看的三条内容整理成一封简短邮件，不会频繁打扰。",
  },
];